<template>
  <div class="chatroom_container">

        <!-- 當前票卷 -->
        <section class="contaner_one" ref="header">
            <ChatroomCurrentTicket 
                :ticket_info="talk_info"
            ></ChatroomCurrentTicket>
        </section>

        <!-- <%--聊天區塊--%> -->
        <section :style="'height:'+chat_height+'px'" class="chat_msg" :class="talk_block_flag?'opacity':'visibility'">
            <div class="talk_block_container" v-for="item in talk_info.chats" :key="item.msg_id">
                <!-- <pre>{{item.msg_id}}</pre> -->
                <!-- <%----------------------------------------------------------------------------------------------------------------------------------%>
                <%--右(本人)一般訊息--%> -->
                <div class="talk_block right" v-if="item.from_type == 1 & item.msg_type == 0" :id="item.msg_id">
                    <div class="dialog right_arrow">
                        <div class="talk_content">
                            {{item.msg_content}}
                        </div>
                        <div class="read_detail">
                            <p class="read_status" v-if="item.read_time!=''">已讀</p>
                            <!-- <%--<p class="send_time">{{(item.send_time).substring(11,16)}}</p>--%> -->
                            <p class="send_time">{{ (item.send_time).substring(11,16) | handle_AM_PM}}</p>
                        </div>
                    </div>
                    <div class="head_img">
                        <span>{{user_name}}</span>
                    </div>
                </div>

                <!-- <%--左(他人)一般訊息--%> -->
                <div class="talk_block left" v-if="item.from_type == 0 & item.msg_type == 0" :id="item.msg_id">
                    <div class="head_img">
                        <span>{{coustom_name}}</span>
                    </div>
                    <div class="dialog left_arrow">
                        <div class="talk_content">
                            {{item.msg_content}}
                        </div>
                        <div class="read_detail">
                            <p :data-status="item.read_time ==''?'unread':'readed'" :data-newest="item.newest?'yes':'no'"></p>
                            <p class="send_time">{{ (item.send_time).substring(11,16) | handle_AM_PM}}</p>
                        </div>
                    </div>
                </div>
<!-- ---------------------------------------------------------------------------------------------------------------------------------- -->
                <!-- <%--右(本人)系統訊息--%> -->
                <div class="talk_block right"
                        v-if="(item.from_type == 1 && item.msg_content) && 
                              (        
                                (item.msg_type == 2)|                          
                                (item.msg_type == 3)|
                                (item.msg_type == 4)|
                                (item.msg_type == 5)
                              ) && 
                            (!item.apply_obj)"
                        :id="item.msg_id">
                    <div class="dialog">
                        <div class="talk_content">
                            {{item.msg_content}}
                        </div>
                        <div class="read_detail">
                            <p class="read_status" v-if="item.read_time!=''">已讀</p>
                            <!-- <%--<p class="send_time">{{(item.send_time).substring(11,16)}}</p>--%> -->
                            <p class="send_time">{{ (item.send_time).substring(11,16) | handle_AM_PM}}</p>
                        </div>
                    </div>
                    <div class="head_img">
                        <span>{{user_name}}</span>
                    </div>
                </div>
                <!-- <%--左(他人)系統訊息--%> -->
                <div class="talk_block left" :data-msgId="item.msg_id"
                             v-if="item.from_type == 0 && 
                            (  
                                (item.msg_type == 2)|
                                (item.msg_type == 4)|
                                (item.msg_type == 5)
                            )
                            && 
                            (!item.apply_obj)"
                             :id="item.msg_id">
                    <div class="head_img">
                        <span>{{coustom_name}}</span>
                    </div>
                    <div class="dialog left_arrow">
                        <div class="talk_content">
                            {{item.msg_content}}
                        </div>
                        <div class="read_detail">
                            <p :data-status="item.read_time ==''?'unread':'readed'" ></p>
                            <p class="send_time">{{ (item.send_time).substring(11,16) | handle_AM_PM}}</p>
                        </div>
                    </div>
                </div>
<!-- ---------------------------------------------------------------------------------------------------------------------------------- -->
                <!-- 右(本人)詳細資訊 -->
                <div class="talk_block right"  v-else-if="item.from_type == 1 && item.apply_obj" :id="item.msg_id">
                    
                    <div class="dialog">
                        <div class="talk_content">
                            <div class="card-content">
                                <div class="content_text">

                                    <!-- <%--<p class="title_text" data-ellipsis='' v-if ="item.apply_obj.apply_status_text=='已取消'">劃位申請取消</p>--%> -->
                                    <p class="title_text" data-ellipsis='' v-if ="item.apply_obj.apply_status_text=='申請中'">劃位時間申請</p>
                                    <p class="title_text" data-ellipsis='' v-else-if ="item.apply_obj.apply_status_text=='已劃位'">劃位成功</p>
                                    <p class="title_text" data-ellipsis='' v-else>{{item.msg_content || item.apply_obj.apply_status_text}}</p>
                                        
                                    <hr>
                                    <p class="title_text" data-ellipsis=''>{{item.apply_obj.ticket_class_name}}</p>
                                    <div class="card-content">
                                        <p class="sub_text">票號 ：</p>
                                        <p class="sub_text">{{item.apply_obj.ticket_no}}</p>
                                    </div>
                                    <div class="card-content">
                                        <p class="sub_text">分店 ：</p>
                                        <p class="sub_text">{{item.apply_obj.store_name}}</p>
                                    </div>
                                    <div class="card-content">
                                        <p class="sub_text">時間 ：</p>
                                        <p class="sub_text">{{(item.apply_obj.target_reserve_time).substring(0,16).replace(/-/g,'/')}}</p>
                                    </div>
                                    <div class="card-content">
                                        <p class="sub_text">姓名 ：</p>
                                        <p class="sub_text">{{item.apply_obj.user_name}}</p>
                                    </div>
                                    <div class="card-content" v-if="item.apply_obj.apply_info">
                                        <p class="sub_text">備註 ：</p>
                                        <p class="sub_text">{{item.apply_obj.apply_info}}</p>
                                    </div>
                                </div>
                            </div>
                            <!-- <%--<span :id="item.ticket_item_id" class="cancel" data-dismiss="modal" v-show="item.apply_id == 0 || item.render_flag == 'init'" @click="set_ticket_option(item.apply_obj); post_ticket_option(item);">{{item.btn_text}}</span>--%> -->
                            <span class="cancel" v-if="
                                                        (item.apply_obj.apply_status_text == '已取消' &
                                                         item.apply_obj.apply_status==3 &
                                                         item.msg_type !== 5
                                                         )||
                                                         (item.apply_obj.apply_status_text == '取消劃位邀請' &
                                                            item.msg_type == 2
                                                            ) 
                                                        "
                                                >已取消邀請</span>
                                                
                            <span :id="item.ticket_item_id" class="cancel" v-else-if=" 
                                                            item.apply_obj.apply_status_text == '劃位邀請' || 
                                                            item.render_flag == 'init'"
                                @click="set_ticket_option(item.apply_obj,'reject'); post_ticket_option(item);"
                                                >取消邀請</span> 

                        </div>
                        <div class="read_detail">
                            <p class="read_status" v-if="item.read_time!=''">已讀</p>
                            <p class="send_time">{{ (item.send_time).substring(11,16) | handle_AM_PM}}</p>
                        </div>
                    </div>
                    <div class="head_img">
                        <span>{{user_name}}</span>
                    </div>
                </div>
                
                <!-- <%--左(他人)系統詳細訊息--%> -->
                <div class="talk_block left" :data-msgId="item.msg_id" v-if="item.from_type == 0 && (item.apply_obj || item.reserve_obj)" :id="item.msg_id">
                    <div class="head_img">
                        <span>{{coustom_name}}</span>
                    </div>
                    
                    <div class="dialog cart_type">
                        <div class="talk_content">
                            <div class="card-content">
                                <div class="content_text">
                                    <p class="title_text" data-ellipsis=''>{{item.msg_content || item.apply_obj.apply_status_text}}</p>
                                    <hr>
                                    <p class="title_text" data-ellipsis=''>{{item.apply_obj?
                                                                            item.apply_obj.ticket_class_name:
                                                                            item.reserve_obj.ticket_class_name}}</p>
                                    <div class="card-content">
                                        <p class="sub_text">票號 ：</p>
                                        <p class="sub_text">{{item.apply_obj?
                                                                item.apply_obj.ticket_no:
                                                                item.reserve_obj.ticket_no}}</p>
                                    </div>
                                    <div class="card-content">
                                        <p class="sub_text">分店 ：</p>
                                        <p class="sub_text">{{item.apply_obj?
                                                                item.apply_obj.store_name:
                                                                item.reserve_obj.store_name}}</p>
                                    </div>
                                    <div class="card-content">
                                        <p class="sub_text">時間 ：</p>
                                        <p class="sub_text">{{((item.apply_obj?
                                                                item.apply_obj.target_reserve_time:
                                                                item.reserve_obj.target_reserve_time).substring(0,16)).replace(/-/g,'/')}}</p>
                                    </div>
                                    <div class="card-content">
                                        <p class="sub_text">姓名 ：</p>
                                        <p class="sub_text">{{item.apply_obj?
                                                                item.apply_obj.user_name:
                                                                item.reserve_obj.user_name}}</p>
                                    </div>
                                    <div class="card-content" v-if="item.apply_obj?
                                                                item.apply_obj.apply_info:
                                                                item.reserve_obj.apply_info">
                                        <p class="sub_text">備註 ：</p>
                                        <p class="sub_text">{{item.apply_obj?
                                                                item.apply_obj.apply_info:
                                                                item.reserve_obj.apply_info}}</p>
                                    </div>
                                </div>
                            </div>
                            <!-- <%--<span class="cancel" data-dismiss="modal">已取消申請</span>--%> -->

                            <!-- <%---------店家劃位邀約---------%> -->
                            <div v-if="item.apply_obj">
                                <div class ="rate_btn" v-if="item.apply_obj.apply_from_type == 0 & item.apply_obj.apply_status_text=='待確認中'">
                                    <div>
                                        <div class="f-gray_2 text_style" @click="set_ticket_option(item.apply_obj,'reject'); post_ticket_option(item);">拒絕</div>
                                        <!-- <div class="rate_border"></div> -->
                                        <div :id="item.ticket_item_id" class="f-pink text_style " data-dismiss="modal" v-show="item.apply_id !==0 " @click="set_ticket_option(item.apply_obj); post_ticket_option(item);">接受</div>
                                    </div>
                                </div>
                            </div>
                            <!-- <%------------------%> -->
                            



                        </div>
                        <div class="read_detail">
                            <p :data-status="item.read_time ==''?'unread':'readed'" ></p>
                            <!-- <%--<p class="send_time">{{(item.send_time).substring(11,16)}}</p>--%> -->
                            <p class="send_time">{{ (item.send_time).substring(11,16) | handle_AM_PM}}</p>
                        </div>
                    </div>
                </div>


            </div>
        </section>



        <!-- 寫訊息、其他功能 -->
        <section class="msg_input_container">
            <div class="input_block">
                <!-- <a class="features"><i class="fa fa-plus" aria-hidden="true"></i></a> -->
                <a class="features" @click="features">
                    <i class="fa fa-plus"><font-awesome-icon :icon="['fa','plus']" /></i>
                </a>
                <input @keyup.enter="post_massage" class="form-control" id="write_msg" v-model='input_msg' value="" type="text" placeholder="輸入訊息">
            
                <!-- <a class="send_msg_icon" @click="post_massage"><i class="fa fa-paper-plane"></i></a> -->
                <a class="send_msg_icon" @click="post_massage">
                    <i class="fa fa-plus"><font-awesome-icon :icon="['fa','paper-plane']" /></i>
                </a>
            </div>

            <div class="features_icon">
                <!-- <pre>{{talk_info.in_chat_tickets}}</pre> -->
                <ul>
                    <li :class="item.ticket_reserve_status =='申請中'? 'stop_option' : 'active_option'"  v-for="item in talk_info.in_chat_tickets" v-bind:key="item.ticket_item_id">
                        <a class="f-icon" @click="active_invitation_view(item)" v-if="item.ticket_item_id == current_ticket_id">
                            <div class='icon footer_icon1'></div>
                            <span>提出劃位</span>
                        </a>
                    </li>
                </ul>
            </div>
        </section>

        

  </div>
</template>

<script>

import ChatroomCurrentTicket from "../Chatroom/ChatroomCurrentTicket";

var that;
export default {
  name: '',
  components:{
    ChatroomCurrentTicket
  },
  props: {
    // 'store_id':Number
  },
  filters:{
        handle_AM_PM : function(value) {
            var hh = value.substring(0,2);
            if(hh > 12){
                hh = value.replace(hh,hh - 12);
                return '下午' + (hh > 9 ? hh:' '+hh);
            }else{
                return '上午' + ((parseInt(hh.substring(0,1)) < 1)? value.replace(hh,hh.substring(1,2)) : value);
            }
        },
        handle_time : function(value) {
            // value = "2019-12-11 17:04:24";

            var amount = new Date().getTime()-new Date(value).getTime(),days;
            amount = Math.floor(amount / 1000),//去掉milliseconds
                days = Math.floor(amount / 86400);//

            //‘-' 換成 '/'
            value = value.replace(/-/g,'/');

            //今天
            // -> 05:11
            if(days == 0){
                value = value.substring(11,16)
            }
            //非今天但在一年內
            // -> 06/11
            else if(days >= 1 & days < 366){
                value = value.substring(5,10)
            }
            //一年前
            // -> 2019/06/11
            else{
                value = value.substring(0,11)
            }

            return value;
        }
    },
  data: function () {
    return {
        talk_info:{},

        //訊息輸入
        input_msg:'',

        //取得新訊息時間
        REFRESH_NEW_MSG_SECONDS:0,
        short_time:3,
        long_time:10,

        //無回傳新訊息次數
        no_change:5,
        // today:new Date(),
        get_new_msg_Interval:{},

        //flag
        api_running:true,
        talk_block_flag:true,
        scroll_flag:false,

        //聊天區塊高度
        chat_height:0,
        
        //紀錄客戶最後ㄧ則msg_id
        client_last_msg_id:0,
        //紀錄當前ticket_id
        current_ticket_id:0,
        //紀錄當前apply_id
        current_apply_id:0,
        //第一筆(已get的訊息)msg_id
        FIRST_MSG_ID:0,
        //最後一筆(已get的訊息)msg_id
        LAST_MSG_ID:0,
        //紀錄操作票卷之APPLY_ID
        OPTION_APPLY_ID:0,
        //操作票卷之ID
        TICKET_ITEM_ID:0
    }
  },
  computed: {
   
  },
  created() {
    this.$on('set_ticket_option',function(){
        this.set_ticket_option([...arguments][0],[...arguments][1])
    });
    this.$on('post_ticket_option',function(res){
        this.post_ticket_option(res)
    });
    this.$on('handler_msg_block_height',function(){
        this.handler_msg_block_height()
    });
    

    //防止重複監聽
    // if(!this.$bus._events.post_ticket_option){}
    this.$bus.$off('post_ticket_option');
    this.$bus.$on('post_ticket_option',function(res){
        that.set_ticket_option(res);
        that.post_ticket_option(res);
    });
    
    
  },
  mounted () {
    that = this;
    that.init();
  },
  methods: {
    init:function () {
            that.coustom_name = (that.$bus.user_info.user_name).substring(0,2);
            that.user_name = (that.$bus.session.name).substring(0,2);
            // var store_info = JSON.parse(localStorage.getItem('store_info'));
            // if(!store_info){
            //         alert('無法取得參數,原因:來源不正確 /n' +
            //             '請從漢堡鈕、票卷內頁點擊進入');
            //         location.href = '/';
            // }else{
                //取得歷史訊息首要設定的參數
                // api.set_STORE_ID(store_info['store_id']);
                // //可傳''
                // api.set_TICKET_ITEM_ID((store_info['ticket_item_id'])||"");
                // //館名
                // that.store_name = store_info['store_name']||"";
                // //上線時間
                // that.last_contact_time = store_info['last_contact_time']||"";

                // that.init_datepicker();
                // that.init_timepicker();
                this.eventListener();

                this.get_history_msg();
            // }

    },

    //事件監聽
    eventListener:function () {
        $('.send_msg_icon').hide();
        var chatroom_now_scroll_top,time_setTime;
        
        //處理聊天室height
        that.handler_chat_container();
        window.onresize = function(){
            that.handler_chat_container();
            //處理聊天區塊height
            that.handler_msg_block_height();
        };
  



        //空白處
        $(document).on('click','.features,.chatroom_container,.msg_input_container',function(e){
            if(!$('#write_msg').val()){
                $('#write_msg').removeClass('active');
                $('.send_msg_icon').hide();
            }
            e.stopPropagation();
            var class_name = e.currentTarget.className;
            if(class_name.indexOf('chatroom_container')>=0){
                $('.msg_input_container').removeClass('active');
                $('.fa-plus').removeClass('plus_transform');
                $('.main_body').removeClass('push_margin');
            }
        });

        //寫訊息
        $(document).on('click','#write_msg',function(e){
            e.stopPropagation();
            $('#write_msg').addClass('active');
            $('.send_msg_icon').fadeIn(200);
        });

        //停止事件傳導
        $(document).on('click','#view_switch_ticket',function(e){
            e.stopPropagation();
        });

        //點擊空白處不關閉
        $('#view_switch_ticket').modal({backdrop: 'static',show:false});
    },

    //+
    features:function(){
        $('.msg_input_container').toggleClass('active');
        $('.fa-plus').toggleClass('plus_transform');
        $('.main_body').toggleClass('push_margin');
    },

    active_invitation_view:function(item){
        if(item.ticket_reserve_status !=='申請中'){
            this.$bus.invitation_ticket = item;
            this.$parent.$emit('chang_view',{
                view:'Appointment'
            });
        }
        
    },

    //取得歷史訊息
    get_history_msg:function(scroll_flag){
      let Param = {
        'module':'store_chat',
        'method':'getStoreUserChats',
        'user_id':this.$bus['user_info']['user_id'],
        'ticket_item_id':'',
        'last_msg_id':that.FIRST_MSG_ID
      }
      that.api_running = true;
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
          }
          
        var res = data.data;
                            
        //有取得資料再處理
        if(res.chats.length > 0 | Object.keys(res.in_chat_tickets).length > 0)
            //首次get處理
            if(!scroll_flag){
                vm.talk_info = res;
                //紀錄當前票卷item_id
                that.current_ticket_id = that.talk_info.current_ticket_id;
                //紀錄當前票卷apply_id
                that.current_apply_id = that.talk_info.in_chat_tickets[that.current_ticket_id]['apply_id'];
               
                that.$nextTick(function () {
                    //for safari borswer
                    if( (that.talk_info.chats).length == 0){
                        that.FIRST_MSG_ID = 0;
                        that.LAST_MSG_ID = 0;
                    }else{
                        //記錄第一筆歷史msg_id
                        that.FIRST_MSG_ID = that.talk_info.chats[0]['msg_id'];
                        //記錄最後一筆歷史msg_id
                        that.LAST_MSG_ID = that.talk_info.chats[that.talk_info.chats.length-1]['msg_id'];
                        //記錄最後一筆店家msg_id
                        that.find_client_last_msg_id();
                    }

                    // //未讀提示
                    that.handle_unread_view();
                    // //啟用自動刷新訊息
                    that.refresh_mag();
                    // //暫時離開處理
                    that.handle_leave_temporarily();
                    // //處理票卷詳細資訊
                    that.change_msg_info_btn('init');

                    that.api_running = false;
                });
            }
            //往上滑取得更早前的歷史訊息,定位處理,目前定於新舊交接處
            else{
                if(res.chats.length > 0){
                    $('.chat_msg').css({'opacity':0});
                    that.talk_block_flag = false;//聊天區塊先隱藏
                    (res.chats).reverse().map(function(val){
                        that.talk_info.chats.unshift(val);
                    });

                    var start = parseInt(res.chats[res.chats.length-1].msg_id),
                        end = parseInt(res.chats[0].msg_id);
                    that.$nextTick(function () {
                        var $end = $('#'+end);
                        $('.hr').remove();
                        $end.parent('.talk_block_container').after("<div class='hr'><hr style='width: 100%'></div>" );
                        $('.chat_msg').animate({
                            //讓撈回來的最後一則底部切齊,置頂票卷區塊底部
                            scrollTop: (($end.position().top + $end.height()))
                        }, function() {
                            $('.chat_msg').css({'opacity':1});
                            that.api_running = false;
                            that.talk_block_flag = true;
                        });
                        //處理票卷詳細資訊
                        that.change_msg_info_btn('init');
                    });
                    //記錄第一筆歷史msg_id
                    that.FIRST_MSG_ID = that.talk_info.chats[0]['msg_id'];
                }
            }
            //讓資料灌完再處理高度
            that.$nextTick(()=>{
                that.handler_msg_block_height();
            });
      },this)
    },

    //計時器相關參數,取得新訊息,3秒/次
    refresh_mag:function(temp_leave_flag){
        var new_time=that.REFRESH_NEW_MSG_SECONDS = that.short_time,
            record_msg_id=that.LAST_MSG_ID,
            no_change=0;
        start_Interval();
        function start_Interval(){
            window.clearInterval(that.get_new_msg_Interval);
            that.get_new_msg_Interval= setInterval(function () {
                console.log(that.REFRESH_NEW_MSG_SECONDS, '秒刷新一次')
                that.update_msg(temp_leave_flag,
                    function (res) {
                        temp_leave_flag=null;
                        if(record_msg_id !== that.LAST_MSG_ID){
                            record_msg_id = that.LAST_MSG_ID;
                            //判斷店家有無已讀(res.new_been_read)
                            //判斷店家有無新訊息(res.new_been_read)
                            if (res.new_chats.length > 0 | res.new_been_read.length > 0) {
                                console.log('持續更新中:', res);
                                no_change                    = 0;
                                that.REFRESH_NEW_MSG_SECONDS = that.short_time;
                            }
                        }
                        else {
                            no_change++;
                            //撈了五次都沒有新資料
                            if (no_change >= that.no_change & that.REFRESH_NEW_MSG_SECONDS != 10) {
                                no_change                    = 0;
                                that.REFRESH_NEW_MSG_SECONDS = that.long_time;
                            }
                        }
                        //確定換秒數就重啟計時器
                        if (new_time != that.REFRESH_NEW_MSG_SECONDS) {
                            new_time = that.REFRESH_NEW_MSG_SECONDS;
                            start_Interval();
                        }
                    }
                );
            },new_time*1000);
        }
    },

    //送出訊息
    post_massage:function(){
        $('.send_msg_icon').hide();
        if(that.input_msg){
            let Param = {
                'module':'store_chat',
                'method':'storeSendChatMsg',
                'user_id':(that.$bus['user_info']['user_id']),
                'ticket_item_id':that.talk_info.current_ticket_id,
                'msg_content':that.input_msg
            }
            
            that.$bus.apiCall(Param, function (data, vm) {
                if (data.ok === 0) {
                    that.$bus.fnShowInfo('呼叫失敗:'+data.msg)
                    return
                }
                //若API成功
                if(data.ok == 1 & data.code == 200 ){
                    //1.push一則新訊息
                    that.talk_info.chats.push({
                        "msg_id": data.data.IdNo,
                        "from_type": 1,
                        "msg_type": 0,
                        "apply_id": 0,
                        "msg_content": that.input_msg,
                        "read_time":'',
                        "send_time": that.make_date()
                    });
                    that.input_msg=null;
                    that.$nextTick(function () {
                        $('.chat_msg').animate({scrollTop:$('.chat_msg').prop('scrollHeight')});
                    });
                    that.update_msg();
                }

            });
        }
    },

    //取得店家新訊息
    update_msg:function(temp_leave_flag,callback) {
        var old_scroll_top = $('.chat_msg').scrollTop();

        let Param = {
                'module':'store_chat',
                'method':'pullStoreUserNewMsgs',
                'user_id':(that.$bus['user_info']['user_id']),
                'last_been_read_msg_id': that.LAST_MSG_ID,
                // 'apply_ids':''
            }
            
        that.$bus.apiCall(Param, function (data, vm) {
            var chat_data =data.data;
            if (data.ok === 0) {
                that.$bus.fnShowInfo('呼叫失敗:'+data.msg)
                return
            }
            
            //若API成功
            if(data.ok == 1 && data.code == 200){

                var push_height=[],tmp_height=0;

                //離開又回來,把全部newest flag(控制以下尚未閱讀提示用)設成0
                if(temp_leave_flag){
                    that.talk_info.chats.map(function (x) {
                        x.newest=0;
                    });
                }
                
                //push新訊息
                chat_data.new_chats.map(function (msg) {
                    //離開又回來,最近一次get的訊息第一則上面區塊增加newest flag
                    if(temp_leave_flag=='temp_unread'){
                        x.newest = 1;
                    }
                    //在push新的訊息前,修改舊資訊卡,按鈕呈現處理
                    that.change_msg_info_btn('pull',(chat_data.new_chats));
                    that.talk_info.chats.push(msg);
                    //定位捲軸用
                    push_height.push(msg.msg_id);
                });


                that.$nextTick(function () {
                    
                    if((chat_data.new_chats).length > 0){
                        
                        // that.change_msg_info_btn('pull',(chat_data.new_chats));
                        that.handler_msg_block_height();
                    }
                   
                    //回傳了票卷操作相關訊息
                    //in_chat_tickets有撈回新資料則同步修改當前票卷
                    that.handle_ticket_info(chat_data);

                    //算新增了多少客戶訊息高度
                    push_height.map(function(x){
                        tmp_height+=$(".left[data-msgId="+ x +"]").height();
                    });

                    //update已讀狀態
                    chat_data.new_been_read.map(function (x) {
                        that.talk_info.chats.map(function (y) {
                            if (y.msg_id == x.msg_id) {
                                //更新我的msg為已讀
                                y.read_time = x.read_time;
                            }
                        });
                    });

                    //客戶有讀取再更新店家最後訊息msg_id
                    if (chat_data.new_chats.length > 0 | chat_data.new_been_read.length > 0) {
                        //設定對方最後msg_id
                        that.find_client_last_msg_id();
                    }

                    //定位捲軸位置
                    console.log('#### Debug 1 ####',!temp_leave_flag)
                    
                    if(!temp_leave_flag){
                        //有新訊息則滾動至最下方
                        //若捲軸不在最下方則不滾動(尚未更新資料前的scroll_top 等於原捲到底的捲軸最底)
                        console.log('#### Debug 2 ####',chat_data.new_chats.length > 0,((old_scroll_top + tmp_height) >= ($('.chat_msg').prop('scrollHeight') - $('.chat_msg').height()) - tmp_height))
                        console.log('#### Debug 3 ####',chat_data.new_chats.length ,(old_scroll_top + tmp_height) , ($('.chat_msg').prop('scrollHeight') - $('.chat_msg').height()) , tmp_height);
                        
                        if(chat_data.new_chats.length > 0 & ((old_scroll_top + tmp_height) >= ($('.chat_msg').prop('scrollHeight') - $('.chat_msg').height()) - tmp_height)){
                            $('.chat_msg').animate({scrollTop:  $('.chat_msg').scrollTop() + $('.chat_msg').height()});
                        }
                    }else{
                        if((chat_data.new_chats).length > 0){
                            //離開又回來scroll應停在未讀訊息第一則
                            temp_leave_flag = null;
                            that.$nextTick(function () {
                                that.handle_unread_view('temp_leave');
                            });
                        }
                    }
                });
                callback && callback(chat_data);
            }
        });

    },

    // in_chat_tickets有撈回新資料則同步修改列表、當前票卷
    handle_ticket_info:function(chat_data){
        //回傳了哪些票卷需要更新狀態
        $.each(chat_data.in_chat_tickets,function (key,val) {
            //更新in_chat_tickets內票卷資訊
            that.talk_info.in_chat_tickets[key] = val;
        });
        //如果有偵測到current_ticket_id有變則切換當前票卷
        if(
            chat_data.current_ticket_id !=  null && 
            that.talk_info.current_ticket_id != chat_data.current_ticket_id
        ){
            that.talk_info.current_ticket_id = chat_data.current_ticket_id;
        }
    },

    //未讀提示
    handle_unread_view:function(flag){
        var _html = '<div class="hr">以下為尚未閱讀的訊息</div>';

        //離開視窗又回來
        if(flag){
            var $first_unread = $("p[data-newest='yes']").first();
            var _hr = $('.hr');
            _hr.remove();
            $first_unread.parents('.talk_block').before(_html);

            $('.chat_msg').animate({scrollTop:  $('.chat_msg').scrollTop() + $('.chat_msg').height()});
        }
        else{
            var $first_unread = $("p[data-status='unread']").first(),
                scroll_top = $first_unread.length!=0?($first_unread.parents('.dialog').offset().top):$('.chat_msg').prop('scrollHeight');

            $('.chat_msg').animate({
                scrollTop: scroll_top
            },100, function() {
                $('.hr').remove();
                $first_unread.parents('.talk_block').before(_html);
                document.querySelector('#chatroom').style.visibility = '';
                //註冊捲軸監聽
                that.scroll_evenlistener();
                that.scroll_flag = true;
            });

        }
    },

    //滾動監聽
    scroll_evenlistener:function(){
        $('.chat_msg').scroll(function () {
            if(
                $(this).scrollTop() <= 0 &&
                !that.api_running &&
                that.FIRST_MSG_ID !== 1 &&
                !$('.chatroom_container').hasClass('display_none') &&
                !$('#view_switch_ticket').hasClass('show')
            ){
                if(that.scroll_flag){
                    that.get_history_msg('scroll_top',$(this).scrollTop());
                }
            }
        });
    },

    //記錄最後一筆客戶msg_id
    find_client_last_msg_id:function(){
        //記錄最後一筆客戶msg_id
        var tmp_arr=(that.talk_info.chats).slice(0).reverse(),
            tmp_id=0;
            
        $.each(
            tmp_arr.filter(
                function(val){
                    return val.from_type == 0;
                }),
            function(key,val){
                if(val.from_type == 0 & !tmp_id){
                    tmp_id = val.msg_id;
                }else{
                    return false; // 等於break
                }
            });
        that.client_last_msg_id = tmp_id;
        return tmp_id;
    },

    //製作日期＋時間
    make_date:function(){
        var now=new Date();
        var month = (now.getMonth()+1),
            day = now.getDate(),
            hh = now.getHours(),
            mm = now.getMinutes();

        function format(val) {
            return (val < 10? ('0'+val):val)
        }
        return now.getFullYear() + '-' + format(month) + '-' + format(day) + ' ' + format(hh) + ':' + format(mm)
    },

    //設定聊天室高度(人名、幾點上線那塊不算)
    handler_chat_container:function(){
        $('.chatroom_container').height 
        (
            $(window).height()
            -$('.navbar')[0].offsetHeight
            -($('.bottom-navigator')[0]?$('.bottom-navigator')[0].offsetHeight:0)
            -$('.top_header')[0].offsetHeight - 10
        );
    },

    //設定聊天訊息區塊高
    handler_msg_block_height:function(){
        try{
            that.chat_height = $('.chatroom_container').height()
                                -that.$refs.header.clientHeight
                                -$('.input_block').height()-2;
        }catch(e){}
    },

    //當聊天室開著,但已被變成背景執行,回到聊天室後重新啟動get_new_msg_Interval
    handle_leave_temporarily:function(){
        
        //畫面離開時(縮小、切換分頁)觸發
        ifvisible.on("blur", function(){
            console.log('你離開了,記錄時間:',new Date());
            window.clearInterval(that.get_new_msg_Interval);
        });

        //畫面回來時(縮小、切換分頁)觸發
        ifvisible.on("focus", function(){
            console.log('你回來了,記錄時間:',new Date());
            //回畫面，現在時間 － 閒置時紀錄的時間
            that.refresh_mag('temp_unread');
        });
    },

    //回聊天室
    goback:function(){
        //在選擇日期頁,回上一頁
        if($('.chatroom_container').hasClass('display_none')){
            //劃位頁隱藏
            $('.seat_info_container').addClass('display_none').removeClass('opacity');
            //聊天室
            $('.chatroom_container').removeClass('display_none');
            document.documentElement.scrollTop = that.chatroom_now_scroll_top;
        }
        else{
            var clicked = JSON.parse(localStorage.getItem('clicked')),
                orgin = clicked?(clicked['href']) : '/';
            if(orgin.match('/ticket-chatroom-list') || orgin.match('/ticket/info/')){
                window.history.go(-1);
            }
        }
    },

    //處理 ""聊天票卷詳細內容"" 按鈕呈現
    change_msg_info_btn:function(str,item_id){
        var apply_obj = 'apply_obj',
            arr_len = (that.talk_info.chats).length,
            chats_arr = (that.talk_info.chats),
            i=0,j=0,
            temp_obj={},return_data;

        //抓最後一筆紀錄起來
        for ( i=(arr_len-1); i > 0; i--) {
            if(!temp_obj.hasOwnProperty((chats_arr[i].ticket_item_id)) && (chats_arr[i]).hasOwnProperty('apply_obj')){
                temp_obj[(chats_arr[i].ticket_item_id)] = chats_arr[i]['msg_content'];
            }
        }
        
        //根據最後一則訊息改變聊天室內關於該張票票卷
        //的詳細資訊卡按鈕
        $.each(temp_obj,function (key,val) {
            console.log('票卷操作:',str,',最後一則票卷資訊卡:',key,val)
            for ( j=(arr_len-1); j > 0; j--) {
                if(
                    chats_arr[j].ticket_item_id == key 
                    && ((str=='init' | str=='pull')?true:item_id==key) 
                    && (chats_arr[j]).hasOwnProperty('apply_obj')
                ){
                    
                    // console.log('要改的obj:',chats_arr[j],'操作類別',str,val);
                    
                    if(
                        val == '申請劃位'//原狀態
                        && str == '接受申請'//改變後狀態
                        && chats_arr[j].ticket_item_id == key
                    ){
                        chats_arr[j].render_flag = 'init';//讓最後一則詳細資訊顯示按鈕
                        if(str=='接受申請'){//操作後狀態
                            chats_arr[j].apply_obj.apply_status_text = '劃位成功';
                            chats_arr[j].render_flag = '';
                            return_data = chats_arr[j];
                        }
                        break;
                    }
                    
                    else if(
                        val == '申請劃位' 
                        && str == '未劃位'
                        && chats_arr[j].ticket_item_id == key
                    ){
                            chats_arr[j].apply_obj.apply_status_text ='取消申請';
                            return_data = chats_arr[j];
                        break;
                    }
                    else if(
                        val == '申請劃位' &
                        str=='pull'
                    ){
                        $.each(item_id,function(msg_key,msg_val){
                            if(msg_val.ticket_item_id == chats_arr[j].ticket_item_id){
                                chats_arr[j].apply_obj.apply_status_text ='取消申請';
                            }
                        });
                    }
                     else if(
                        val == '邀約劃位'
                    ){
                        console.log('要修改的obj:',chats_arr[j])
                        if(str != '未劃位'){
                            chats_arr[j].apply_obj.apply_status_text ='劃位邀請';
                        }else if(str == '未劃位'){
                            chats_arr[j].apply_obj.apply_status_text ='取消劃位邀請';
                        }
                        
                        return_data = chats_arr[j];
                        break;
                    }
                }
            }
        });
        return return_data;
    },

    //票卷操作狀態分配
    set_ticket_option:function(ticket_item,action_type){
       console.log('set_ticket_option',action_type,ticket_item)
        //點擊接受申請
        if(
            !action_type & 
            ticket_item.apply_from_type == 0 &  
            (
                ticket_item.ticket_reserve_status == '申請中'|
                ticket_item.apply_status_text == '待確認中'
            )
        ){
            ticket_item.ticket_reserve_status = '接受申請';
        }
        //點擊拒絕申請
        else if(
                action_type =='reject' & 
                ticket_item.apply_from_type == 0
            ){
            ticket_item.ticket_reserve_status = '拒絕申請';
        }
        //點擊劃位邀請
        else if(
                ticket_item.ticket_reserve_status == '未劃位'
            ){
            ticket_item.ticket_reserve_status = '劃位邀約';
        }
        //點擊取消邀請
        else if(
                (
                    ticket_item.ticket_reserve_status == '申請中'|
                    ticket_item.apply_status_text == '劃位邀請' 
                ) &
                action_type == 'reject' & 
                ticket_item.apply_from_type == 1
            ){
            ticket_item.ticket_reserve_status = '取消邀請';
        }

        that.ticket_option_status = ticket_item.ticket_reserve_status;
        that.OPTION_APPLY_ID = ticket_item['apply_id'];
    },

    //post票卷操作
    post_ticket_option:function(item){
      console.log(item,that.ticket_option_status)
        function new_obj(){
            return JSON.parse(JSON.stringify({
                apply_id: '',
                apply_obj: {
                    apply_by: '',
                    apply_id: '',
                    apply_info: '',
                    apply_status: '',
                    apply_status_text: '',
                    apply_time: '',
                    close_time: '',
                    confirm_use_status: '',
                    store_name: '',
                    ticket_reserve_status:'',
                    target_reserve_time: '',
                    ticket_class_name: '',
                    ticket_no: '',
                    user_name: ''
                },
                from_type: '',
                msg_content: '',
                msg_id: '',
                msg_type: '',
                read_time: '',
                send_time:'',
                store_account_id: '',
                store_user_name: '',
                ticket_item_id: '',
                btn_text: ''
            }))
        }
        console.log('票卷操作取得object : ',that.ticket_option_status,item);

        var _res = {},
            change_ticket_status='',
            apply_obj = 'apply_obj',
            msg_data = {};
        that.TICKET_ITEM_ID = item['ticket_item_id'];
        switch (that.ticket_option_status){
            //--------------------------------------------------------------------------------
            //接受劃位申請
            case'接受申請':
                change_ticket_status = '接受申請';
                // console.log(this.chooser.result.get_val()['value'],this.chooser.result.get_val1()['value'])
                // var reserve_target_time =  $("#datepicker").datepicker().val()+' '
                //     +this.chooser.result.get_val()['value'] +':'
                //     +this.chooser.result.get_val1()['value'] +':'
                //     +'00';

                if(Object.keys(item).indexOf("apply_obj") > 0){
                    item['apply_obj']['apply_from_type'] = 0;
                }else{
                    item['apply_from_type'] = 0 ;
                }
                
                let Param = {
                    'module':'store_chat',
                    'method':'acceptApplyByStore',
                    'apply_id':that.OPTION_APPLY_ID,
                    'via_chat': 1,
                }
                
                that.$bus.apiCall(Param, function (data, vm) {
                    if (data.ok === 0) {
                        that.$bus.fnShowInfo('呼叫失敗:'+data.msg)
                    return
                    }
                    //若API成功
                    if(data.ok == 1 & data.code == 200 ){
                    //劃位成功,處理票卷列表、當前票卷apply_id,並由前端發出票卷明細於聊天室
                        _res = data;
                        handle_data();
                        msg_data = that.change_msg_info_btn(change_ticket_status,item.ticket_item_id).apply_obj;
                        var obj = new_obj();
                            // obj[apply_obj].apply_by = "user";
                            obj[apply_obj].apply_id= _res.data.IdNo;
                            // obj[apply_obj].apply_info= that.user_remark;
                            obj[apply_obj].apply_status_text= "劃位成功";
                            obj[apply_obj].store_name= msg_data.store_name;
                            obj[apply_obj].ticket_reserve_status='已劃位';
                            obj[apply_obj].target_reserve_time= msg_data.target_reserve_time;
                            obj[apply_obj].ticket_class_name= msg_data.ticket_class_name;
                            obj[apply_obj].ticket_no= msg_data.ticket_no;
                            obj[apply_obj].user_name= msg_data.user_name;
                            obj['from_type']= 1;
                            // obj['msg_content']= '劃位時間申請';
                            obj['msg_type']= 2;
                            obj['send_time']= that.make_date();
                            obj['ticket_item_id']= that.TICKET_ITEM_ID;
                        //1.push一則"劃位時間申請"系統訊息
                        that.talk_info.chats.push(obj);
                        scroll_position();
                    }
                });
                break;
            //--------------------------------------------------------------------------------
            //取消申請
            case'拒絕申請':
                if(item.hasOwnProperty('apply_obj')){
                    item.apply_from_type = item.apply_obj.apply_from_type;
                }

                if(!item.apply_from_type){
                    change_ticket_status = '未劃位';
                     let Param = {
                        'module':'store_chat',
                        'method':'rejectApplyByStore',
                        'apply_id':that.OPTION_APPLY_ID,
                        'via_chat': 1,
                    }
                    that.$bus.apiCall(Param, function (data, vm) {
                        if (data.ok === 0) {
                            that.$bus.fnShowInfo('呼叫失敗:'+data.msg)
                        return
                        }
                        //若API成功
                        if(data.ok == 1 & data.code == 200 ){
                            _res = data;
                            handle_data();
                            msg_data = that.change_msg_info_btn(change_ticket_status,item.ticket_item_id).apply_obj;
                            var obj = new_obj(),apply_obj = 'apply_obj';
                                obj[apply_obj].apply_status_text= "取消劃位申請";
                                obj[apply_obj].apply_info= msg_data.apply_info;
                                obj[apply_obj].store_name= msg_data.store_name;
                                obj[apply_obj].target_reserve_time= msg_data.target_reserve_time;
                                obj[apply_obj].ticket_class_name= msg_data.ticket_class_name;
                                obj[apply_obj].ticket_no= msg_data.ticket_no;
                                obj[apply_obj].user_name= msg_data.user_name;
                                obj['apply_id'] = 'null';
                                obj['from_type']= 1;
                                obj['msg_type']= 2;
                                obj['send_time']= that.make_date();
                                obj['ticket_item_id']= that.TICKET_ITEM_ID;
                                // obj['store_name']= item.apply_obj.store_name | that.$bus.session.name;

                            that.talk_info.chats.push(obj);
                            scroll_position();
                        }
                    });
                }

                break;
            
            // //--------------------------------------------------------------------------------
            // //劃位邀約
            case'劃位邀約':
                change_ticket_status = '劃位邀約';

                var Param = {
                        'module':'store_chat',
                        'method':'applyReserveByStore',
                        'user_id':that.$bus['user_info']['user_id'] ,
                        'ticket_item_id':that.TICKET_ITEM_ID,
                        'remark': that.$bus.invitation_info.user_remark,
                        'reserve_target_time':that.$bus.invitation_info.date,
                        'via_chat': 1
                    };
                    that.$bus.apiCall(Param, function (data, vm) {
                        if (data.ok === 0) {
                            that.$bus.fnShowInfo('呼叫失敗:'+data.msg)
                        return
                        }
                        //若API成功
                        if(data.ok == 1 & data.code == 200 ){
                            that.$parent.$emit('chang_view',{
                                view:'ChatroomView'
                            });
                        }
                    });
                break;
            // //--------------------------------------------------------------------------------
            // //取消邀請
            case'取消邀請':
                // api.set_RESERVE_ID(that.talk_info.in_chat_tickets[item.ticket_item_id]['reserve_id']);
                change_ticket_status = '未劃位';
                 var Param = {
                        'module':'store_chat',
                        'method':'cancelApplyByStore',
                        'apply_id':that.OPTION_APPLY_ID,
                        'via_chat': 1
                    };
                    that.$bus.apiCall(Param, function (data, vm) {
                        if (data.ok === 0) {
                            that.$bus.fnShowInfo('呼叫失敗:'+data.msg)
                        return
                        }
                        //若API成功
                        if(data.ok == 1 & data.code == 200 ){
                             _res = data;
                            handle_data();
                            msg_data = that.change_msg_info_btn(change_ticket_status,item.ticket_item_id).apply_obj;
                            
                            var obj = new_obj(),apply_obj = 'apply_obj';
                                obj[apply_obj].apply_status_text= "取消劃位邀請";
                                obj[apply_obj].apply_info= msg_data.apply_info;
                                obj[apply_obj].store_name= msg_data.store_name;
                                obj[apply_obj].target_reserve_time= msg_data.target_reserve_time;
                                obj[apply_obj].ticket_class_name= msg_data.ticket_class_name;
                                obj[apply_obj].ticket_no= msg_data.ticket_no;
                                obj[apply_obj].user_name= msg_data.user_name;
                                obj['apply_id'] = 'null';
                                obj['from_type']= 1;
                                obj['msg_type']= 5;
                                obj['send_time']= that.make_date();
                                obj['ticket_item_id']= that.TICKET_ITEM_ID;
                                // obj['store_name']= item.apply_obj.store_name | that.$bus.session.name;
                            
                            that.talk_info.chats.push(obj);
                            scroll_position();
                        }
                    });
                break;
            default:
                that.handler_msg_block_height();
                // alert('不該跑來這喔！<br> item.ticket_reserve_status 檢查一下！')
        }


        //處理訂位時間
        function handle_target_reserve_time() {
            var target_reserve_time;
            //因點當前票卷區塊無劃位時間故要從聊天訊息抓
            if(!item.hasOwnProperty('apply_obj')){
                if(!item.apply_id){
                    target_reserve_time = item.reserving_time;
                }else{
                    that.talk_info.chats.map(function (x) {
                        if(x.hasOwnProperty('apply_obj')){
                            if(x.apply_obj.apply_id  == that.talk_info.in_chat_tickets[api.get_TICKET_ITEM_ID()]['apply_id']){
                                target_reserve_time = x.apply_obj.target_reserve_time;
                            }
                        }
                    });
                }
            }else{
                target_reserve_time = item.apply_obj.target_reserve_time;
            }
            return target_reserve_time
        }

        //處理票卷名稱、票號
        function hadle_ticket_data() {
            var ticket_obj = {};
            if(!item.hasOwnProperty('apply_obj')){
                ticket_obj.ticket_project_name = item.ticket_project_name;
                ticket_obj.ticket_no = item.ticket_no;
            }else{
                ticket_obj.ticket_project_name = item.apply_obj.ticket_class_name;
                ticket_obj.ticket_no = item.apply_obj.ticket_no;
            }
            return ticket_obj;
        }

        //處理聊天室置頂區塊票卷資訊、票卷清單列表
        function handle_data(flag){//flag區別店家邀約用
            //票卷列表
            // that.tickets_list_info.map(function (x) {
            //     if(x.ticket_item_id == item.ticket_item_id ){
            //         handler(x);
            //     }
            // });
            
            //若點擊的按鈕剛好是聊天室當前票卷,在修改
            if(that.talk_info.in_chat_tickets.hasOwnProperty(item.ticket_item_id)){
                handler(that.talk_info.in_chat_tickets[item.ticket_item_id]);
            }
            //塞入apply_id、票卷目前處理狀態
            function handler(obj) {
                if(flag == false){
                    obj['reserve_id'] = _res.data.IdNo;
                }
                else if(_res.data){
                    obj['apply_id'] = _res.data.IdNo;
                }
                obj['ticket_reserve_status'] = change_ticket_status;

                //申請劃位完把'備註'塞到當前置頂票卷apply_info
                if(that.user_remark){
                    obj['apply_info'] = that.user_remark;
                }
            }

        }

        //定位捲軸位置
        function scroll_position(){
            that.$nextTick(function () {
                that.handler_msg_block_height();
                $('.chat_msg').animate({scrollTop: $('.chat_msg').prop('scrollHeight')});
            });
        }


        
    },

  },
  destroyed: function () {
    ifvisible.off('blur');
    ifvisible.off('focus');
    window.clearInterval(that.get_new_msg_Interval);
  }
}
    
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .chatroom_container{
        background-color: #e5e5e5;
        position: relative;
        hr{
            margin:10px 0;
        }
        .contaner_one{
            width: 100%;
            padding: 7px;
        }
        .content_text .card-content p:nth-child(1){
            flex:  0 50px;
        }
        .content_text .card-content p:nth-child(2){
            /*margin-top: 7px;*/
            flex: 1;
        }
        .opacity{
            opacity:1;
            transition: 0.3s;
        }
        .stop_option{
            opacity: 0.3;
        }
        .active_option{
            opacity: 1;
        }
        .rate_btn .rate_border{
            border-right: 1px solid #e9ecef;
            margin: 10px 0;
        }
        
        .ticket_info{
            .card-content p{
                margin-left: 10px;
            }
            .content_text p:first-child{
                text-align: left;
            }
            .sub_text{
                font-size: 14px;
                margin-top: 3px;
            }
            .right .content_text{
                color: #FFFFFF;
            }
        }
        
        .chat_msg{
            position: relative;
            overflow-y: auto;
            // border: 1px solid var(--main-color);
             /*已讀位置/顏色*/
            .read_detail{
                font-size: 10px;
                color: #999999;
                position: absolute;
                bottom: 0px;
            }
            .right .read_detail{
                text-align: right;
                left: -60px;
            }
            .left .read_detail{
                right: -60px;
            }
            /*對話框共用*/
            .content_text .title_text:nth-child(1){
                text-align: center;
            }
            .talk_block{
                margin: 15px 0;
                display: flex;
                position: relative;
                //頭像
                .head_img{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 50px;
                    height: 50px;
                    background-color: #d9dfe2;
                    margin: 0 5px;
                    box-shadow: 1px 3px 3px 0px #cac8c8;
                    border-radius: 50%;
                    span{
                        font-size: 18px;
                        color: #ffffff;
                    }
                }
            }
            .talk_block.right{
                justify-content: flex-end;
            }
            .talk_block.left .dialog{
                margin-left: 20px;
                background-color: #fff;
            }
            /*對話框*/
            .talk_block .dialog{
                max-width: 55%;
                border-radius: 20px;
                background-color: #b4557c;
                position: relative;
                margin-right: 20px;
                padding: 10px;
                display: flex;
                justify-content: center;
                align-items: center;
                box-sizing: content-box;
                text-align: left;
                .sub_text{
                    font-size: 14px;
                    margin: 5px 0;
                    font-weight: 900;
                }
            }
            .talk_block .right_arrow:after,
            .talk_block .left_arrow:after{
                content: '';
                top: 20px;
                margin-left: -19px;
                border-top: 8px solid transparent;
                border-bottom: 8px solid transparent;
                border-left: 0; position: absolute;
            }

            .talk_block .right_arrow:after{
                border-right: 25px solid #b4557c;
                right: -19px;
                transform: rotate(180deg);
            }

            .talk_block .left_arrow:after{
                border-right: 25px solid #fff;
                left: 0;
                transform: rotate(0deg);
            }
            /*對話文字顏色*/
            .talk_content{
                font-size: 18px;
                font-weight: bold;
                word-wrap: break-word;
                .title_text:nth-child(3){
                    margin:7px 0;
                }
                
            }
            .right .talk_content .cancel,
            .right .talk_content{
                color: #ffffff;
            }
            .left .talk_content{
                color: #222222;
            }
            .talk_block .left .content_text p{
                color: black;
            }
            .talk_block .content_text p:nth-child(1){
                margin-bottom: 7px;
            }

            .talk_block .dialog.cart_type{
                background-color: #fff;
            }
            .talk_block .cancel,
            .talk_block .seat
            {
                color: #fff;
                font-size: 18px;
            }
            .talk_block.left .cancel{
                color: var(--main-color);
            }
            .right hr{
                border-color: white;
                margin-bottom:10px;
            }
            .hr{
                text-align: center;
                background-color: gray;
                color: white;
                border-radius: 50px;
                font-size: 10px;
            }
        }
       
        .send_msg_icon{
            display: none;
            position: relative;
            top: 15px;
            right: 10px;
            margin: 0 10px;
            font-size: 25px;
         }
         /*打字框*/
        .msg_input_container{
            position: absolute;
            bottom:0;
            width: 100%;
            background-color: #f7f7f7;
            overflow-y: hidden;
            transform: translateY(80px);
            transition: 0.2s;
            .input_block{
                display: flex;
            }
            .form-control{
                height: 43px;
                width: 90%;
                margin: 7px 0;
                margin-right: 18px;
                padding-left:18px;
                transition: width 1s;
                border-radius: 50px;
            }
        }
        .features_icon ul{
            padding: 0;
            margin: 0;
        }
        .features {
            position: relative;
            top: 18px;
            margin: 0 20px;
        }

        .fa-plus:before{
            font-size: 23px;
            color: #3d465b;
        }
        .footer_icon1{
            background: url("../../assets/images/chroom_img/pink-home.png")no-repeat ;
            background-size: 90%;
            background-color: white;
            background-position: center;
        }
        .footer_icon2{
            background: url("../../assets/images/chroom_img/pink-order.png")no-repeat ;
            background-size: 90%;
            background-color: white;
            background-position: center;
        }
        /*功能icon*/
        .features_icon{
            display: flex;
            min-height: 80px;
            border-top: solid thin #CCCCCC;
        }
        .f-icon {
            padding: 0;
            height: 57px;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            align-items: center;
            font-size: 14px;
            font-weight: bolder;
        }
        .f-icon div {
            height: 36px;
            width: 36px;
        }
        .f-icon span {
            width: 100%;
            text-align: center;
            color:var(--main-color);
            font-size: 16px;
            margin-top: 20px;
        }
        ul{
            display: flex;
            list-style: none;
            justify-content: center;
            align-items: center;
        }
        ul li {
            flex: 1;
        }
        .icon{
            margin-bottom: -18px;
            margin-top: -7px;
            border-radius: 50%;
        }

        .active{
            transform: translateY(0px);
            transition: 0.2s;
        }
        .plus_transform{
            transform: rotate(45deg);
            transition: 0.5s;
        }
        .main_body.push_margin{
            margin-bottom:154px;
        }

        #chatroom .modal .modal-body{
            padding:14px;
            height: 80vh;
            overflow: auto;
        }
        .rate_btn{
            border-top:solid 1px #eeeeee;
            margin: 5px 0 0;
            div div:first-child{
                border-right:solid 1px #eeeeee;
            }
            div{
                padding-top: 5px;
                display: flex;
                flex: 1;
                align-items: center;
                justify-content: center;
            }
        }
     
    }
    
</style>
